'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import parse, { domToReact, type HTMLReactParserOptions, Element } from 'html-react-parser';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { usePathname } from 'next/navigation';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

interface HeadingProps {
  title: string;
  className?: {
    title?: string;
    subtitle?: string;
    container?: string;
    vector?: string;
  };
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  visualTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export function Heading({ title, className, tag = 'h2', visualTag = tag }: HeadingProps) {
  const pathname = usePathname();

  const isPartnerPage = pathname === ROUTES.PARTNERS();

  const Tag = tag;

  const parsedTitle = parse(title ?? '', {
    replace: domNode => {
      if (domNode instanceof Element && domNode.name === 'span') {
        return (
          <span {...domNode.attribs} className="relative">
            {domToReact(domNode.children as any)}
            <Image
              src={`/images/heading-vector${isPartnerPage ? '-partner' : ''}.svg`}
              alt="Line"
              height={0}
              width={0}
              className={cn(
                'absolute -bottom-0 left-0 z-[-1] h-auto w-full object-contain object-center',
                className?.vector,
              )}
            />
          </span>
        );
      }
    },
  } as HTMLReactParserOptions);

  return (
    <div className={cn('', 'ea-heading__container', className?.container)}>
      <Tag
        className={cn(
          'relative z-[5] font-medium tracking-tighter text-foreground',
          'ea-heading__title',
          visualTag,
          className?.title,
        )}
      >
        {parsedTitle}
      </Tag>
    </div>
  );
}
